/**
 * @generated SignedSource<<c63abead1894383be1bfd685edfd4cef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailsTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutModule_viewer" | "PdpRespDealerDetails_viewer">;
  readonly " $fragmentType": "PdpRespDetailsTabs_viewer";
};
export type PdpRespDetailsTabs_viewer$key = {
  readonly " $data"?: PdpRespDetailsTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailsTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailsTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "dcd2c7c8833dddb158f0c5c78b997d90";

export default node;
